'use client';

import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';

import { TourTabHeading } from '../tour-content';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { ReferenceCard } from '../../../reference/reference-card';
import { TourBlogs } from '../../tour-blogs';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export function ReviewsTab({ tour }: { tour: TravelAgencyTour }) {
  const locale = useLocaleStore(s => s.currentLocale);
  const { t } = useTranslations();

  return (
    <>
      <div className="flex w-full flex-col items-start justify-start gap-6 lg:gap-8">
        <TourTabHeading title={t('text1091')} />
        <div className={cn('grid w-full grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3')}>
          {tour.references.map(reference => (
            <ReferenceCard reference={reference} key={reference.slug} />
          ))}
        </div>
      </div>
      {tour.id === 11 && <TourBlogs locale={locale} />}
    </>
  );
}
